import { hasNetrustTrialContext } from "./borrower/profile staging/netrustTrial";
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import {
  authRoutes,
  verifyRoutes,
  dashboardRoutes,
  verticalRoutes,
  borrowerDashboardRoutes,
  adminDashboardRoutes,
  landingPageRoutes,
  supportRoutes,
  portalRoutes,
} from "./routes/routes";
import Authlayout from "./layout/Authlayout";
import Verifylayout from "./layout/Verifylayout";
// import Adminlayout from "./layout/Adminlayout";
// import Dashboardlayout from "./layout/Dashboardlayout";
import VerticalLayout from "./layout/VerticalLayout";
import DashboardLayout from "./pages/dashboard/dashboard";
import DashboardBorrowerLayout from "./pages/borrower-dashboard/borrower-dashboard";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";

import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import RequestLoanTable from "./scenes/loan-request-list";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import DashboardAdminLayout from "./pages/admin-dashboard/admin-dashboard";
import LandingPagelayout from "./layout/LandingPagelayout";
import { ToastContainer, toast } from "react-toastify";
import UserJourneyAnalyticsTracker from "./components/analytics/UserJourneyAnalyticsTracker";
import BauthConf from "./borrower/profile staging/bauthconf";
import UrlLoginTokenHandler from "./components/UrlLoginTokenHandler";

const PlainLayout = ({ children }) => <>{children}</>;

const isCrmSyncCallback = (location) => {
  const state = new URLSearchParams(location.search).get("state");
  return typeof state === "string" && state.startsWith("slcrm_") && !hasNetrustTrialContext(state);
};

library.add(faSearch);
// Multi-layout function
const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout>
        <Component {...props}></Component>
      </Layout>
    )}
    exact
  ></Route>
);
function App() {
  // const [theme, colorMode] = useMode();
  // const [isSidebar, setIsSidebar] = useState(true);
  window.onerror = function (message, url, line, column, error) {
    fetch("https://www.smart-lend.com/api/user/logError", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: message,
        url: url,
        line: line,
        column: column,
        stack_trace: error?.stack || null,
        user_id: Cookies.get("email") || "Browser",
      }),
    }).catch((err) => console.error("Failed to log error:", err));
  };

  return (
    <Router>
      <UrlLoginTokenHandler />
      <UserJourneyAnalyticsTracker />
      <Switch>
        <Route
          exact
          path={["/b-profile", "/stg-b-profile"]}
          render={(props) =>
            isCrmSyncCallback(props.location) ? (
              <LandingPagelayout>
                <BauthConf {...props} />
              </LandingPagelayout>
            ) : (
              <DashboardBorrowerLayout />
            )
          }
        />
        {authRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={Authlayout}
          />
        ))}
        {landingPageRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={LandingPagelayout}
          />
        ))}
        {verifyRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={Verifylayout}
          />
        ))}
        {dashboardRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={DashboardLayout}
          />
        ))}
        {borrowerDashboardRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={DashboardBorrowerLayout}
          />
        ))}
        {adminDashboardRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={DashboardAdminLayout}
          />
        ))}
        {supportRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={PlainLayout}
          />
        ))}
        {portalRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={PlainLayout}
          />
        ))}
        {verticalRoutes.map((route, idx) => (
          <AppRoute
            key={idx}
            path={route.path}
            component={route.component}
            layout={VerticalLayout}
          />
        ))}
        <Redirect strict from="/" to="/home" />
      </Switch>

      <ToastContainer />
    </Router>
  );
}

export default App;
